import React from "react";
import { toElementProps } from "../../Element.js";
import { GriderStyles } from "./Grider.jsx";

export function BlockProductDescriptionStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;
    return {
        "& .block-product-description": {
            padding: "0 40px",
            margin: "0 auto",
            width: "100%",
            color: palette.primary.initialText,
        },

        "& .product-description-content": {
            padding: "40px",
            margin: "0 auto",
            maxWidth: "1200px",
            display: "grid",
            gridTemplateColumns: "1fr 3fr",
            gap: "20px",
            alignItems: "start",

            [MobileBreakpoint]: {
                gridTemplateColumns: "1fr",
                padding: "20px",
                maxWidth: "100%",
            },
        },

        "& .product-description-title": {
            fontSize: "24px",
            fontWeight: "bold",
            textTransform: "uppercase",
            alignSelf: "flex-start",
        },

        "& .product-description-text": {
            fontSize: "16px",
            lineHeight: "1.5",
        },

        ...GriderStyles(params),
    };
}

export default function BlockProductDescription(props) {
    const { ProductDescription, TechnicalSpecs, Texts } = props.variables;

    if (!ProductDescription && !TechnicalSpecs) {
        return null;
    }

    if (typeof TechnicalSpecs !== "string") {
        console.warn("Technical specs is not string!");
        return null;
    }

    const elProps = toElementProps(props, { className: ["block-product-description"] });

    return (
        <div {...elProps}>
            {ProductDescription && (
                <div className="product-description-content">
                    <div className="product-description-title">
                        {Texts?.ProductDescription || "Product Description"}
                    </div>

                    <div className="product-description-text">{ProductDescription}</div>
                </div>
            )}

            {TechnicalSpecs && (
                <div className="product-description-content">
                    <div className="product-description-title">
                        {Texts?.TechnicalSpecs || "Technical Specifications"}
                    </div>

                    <div className="product-description-text">{TechnicalSpecs}</div>
                </div>
            )}
        </div>
    );
}
